import PropTypes from 'prop-types';

import { HideOnPrint } from 'components';

import ErrorBoundary from './ErrorBoundary';

const PageLayout = ({ children, aside, asidePrintable = false }) => {
	const sidebarElement = (
		<div className="Dashboard-aside">
			<ErrorBoundary>{aside}</ErrorBoundary>
		</div>
	);

	return (
		<div className="Dashboard-container">
			<div className="Dashboard-mainWrapper">
				<ErrorBoundary>{children}</ErrorBoundary>
			</div>

			{aside && (asidePrintable ? sidebarElement : <HideOnPrint>{sidebarElement}</HideOnPrint>)}
		</div>
	);
};

PageLayout.propTypes = {
	aside: PropTypes.node,
	asidePrintable: PropTypes.bool,
	children: PropTypes.node,
};

export default PageLayout;
